import { createContext, useContext } from 'react'

export interface PollFormContextValues {
  hasAlreadyVoted: boolean
  mode: 'create' | 'edit'
}

export const PollFormContext = createContext<PollFormContextValues | null>(null)

export function usePollFormContext() {
  const context = useContext(PollFormContext)
  if (!context) {
    throw new Error('usePollFormContext must be used within a PollFormContext')
  }
  return context
}
